<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月23日 18:08:37
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div class="one-implement">
        <div class="one-implement-head">
            <div class="one-implement-top">
                <el-image
                class="implement-image"
                shape="square"
                fit="cover"
                :src="(elder&&elder.ImgUrl)||avatar"></el-image>
                <div class="implement-main">
                    <div class="implement-message">
                        <span class="name">{{(elder&&elder.Name)}}</span>
                        <span class="level">{{(elder&&elder.CareLevel)}}</span>
                        <span class="room">房号: {{(elder&&elder.Room)}} </span>
                    </div>
                    <div class="implement-num">
                        <div class="implement-all-check">
                            <i class="el-icon-check"></i>
                        </div>
                        <span>执行</span>
                        <span v-if="elder">（{{elder.TotalCare-elder.NotExecuted}}/{{elder.TotalCare}}）</span>
                    </div>
                </div>
            </div>
            <div class="implement-filter">
                <filterBtn></filterBtn>
                <div class="btn-list">
                    <div v-if="implementType==1 && showBtn" @click="allSetUp(false)" class="all-btn all-cancel" type="primary" plain>全部取消</div>
                    <div v-if="implementType==1 && showBtn" @click="allSetUp(true)" class="all-btn all-sure" type="primary" plain>全部确认</div>
                </div>
            </div>
        </div>

        <div class="implement-row">
            <div @click="selectImplement(1)" :class="[implementType==1?'active-implement':'','already-implement']">未执行</div>
            <div @click="selectImplement(2)" :class="[implementType==2?'active-implement':'','not-implement']" >已执行</div>
        </div>

        <div class="implement-list">
            <template v-if="implementList&&implementList.length">
                <div class="implement-item" v-for="item in implementList" :key="item.Id">
                    <div class="time">
                        <!-- <span>时间:</span> -->
                        <span>{{item.newDTime}}</span>
                    </div>
                    <div class="line"></div>
                    <implementItemFooter :obj="item" :task="item.Message" :status="item.Status" :oldStatus="item.oldStatus" :time="item.newDTime" :InputDate="item.newInputDate" :remark="item.Remark" :userName="item.CUser"
                    :hasHistoryRecords="item.HistoryRecords?item.HistoryRecords.length>0:false" :Value="item.Value" @check="check" @close="close" @getHistory="getHistory" @setRemark="setRemark" ></implementItemFooter>
                </div>
            </template>
            <tips v-else></tips>
        </div>
        <pager @changePage="changePage" @changeSize="changeSize" :page='page+1' :total="total" :size="size"></pager>
        <!-- 全部执行弹框-->
        <myDialog :dialogVisible="dialogVisible" :question="question" @close="allClose" @setup="allSetup" dialogWidth="66%"></myDialog>
        <!-- 执行弹框-->
        <template>
            <implementRemark :activeObj="activeObj" :isVisible='implementVisible' :remakeType="remakeType" :ProfileName="activeObj.ProfileName" :Message="activeObj.Message" 
            :initRemark="activeObj.Remark" :initInput="activeObj.Value" :ImgUrl="activeObj.ImgUrl" :initStatus='activeObj.Status' :initModels="cloneDeep(activeObj.Models)" :Id='activeObj.Id' 
            :InputType="activeObj.InputType" @close="closeRemark" @closeStatus="closeStatus" @execution="execution"></implementRemark>
        </template>
        
    </div>
</template>

<script>
import {cloneDeep} from 'lodash'
import implementRemark from '@/common/implement-remark.vue'
import filterBtn from '@/common/filter-btn.vue'
import implementItemFooter from '@/common/implement-item-footer.vue'
import myDialog from '@/common/dialog.vue'
import pager from '@/common/pager.vue'
import tips from '@/common/tips.vue'
import {group,timeCompared} from '@/tool'
import { mapState,mapActions } from 'vuex'
import avatar from "@/assets/imgs/avatar.png";
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
      filterBtn,
      implementItemFooter,
      implementRemark,
      myDialog,
      pager,
      tips
  },
  // 组件状态值
  data () {
   return {
    size:10,
    page:0,
    total:10,
    activeObj:{},
    //1完成弹框2拒绝弹框3备注
    remakeType:1,
    implementVisible:false,
    dialogVisible:false,
    question:"是否确认所有记录？",

    implementType:1,
    avatar
   }
  },
  // 计算属性
  computed: {
    ...mapState(['ElderlyCares','Items','NurseSignatureViews','saveVal']),
    ...mapState('filter',['selectDetails','selectRooms','activeShifts']),
    elder(){
        return this.ElderlyCares.filter(item=>item.Id==this.$route.query.Id)[0]
    },
    showBtn(){
            return !this.$store.state.isScanCode  || this.$store.state.scanCode === this.$route.query.Id 
    },
    implementHistory(){
        let ItemsArr=this.Items.filter(item=>{
            let time=item.DTime.split('T')[1]
            return (!this.selectDetails.length||this.selectDetails.indexOf(item.Message)!=-1)&&
            (!this.activeShifts.length||this.activeShifts.indexOf(timeCompared(time))!=-1)&&
            item.ProfileName==(this.elder&&this.elder.Name)&&
            (this.implementType==1?item.oldStatus===null:item.oldStatus!==null)
        })
        this.total=ItemsArr.length
        if(this.page*this.size>=this.total){
            this.page=0
        }
        return ItemsArr
    },
    implementHistoryArr(){
        let ItemsArr=group(this.implementHistory,this.size)
        return ItemsArr||[[]]
    },
    implementList(){
      return this.implementHistoryArr[this.page]
    },
    
   

  },
  // 侦听器
  watch: {
    saveVal(val){  
      let nowTime=new Date().getTime()
      let Items=this.implementHistory.filter(item=>item.IsEdit==1&&new Date(item.newDTime).getTime()<=nowTime)
      if(Items.length){
        this.updateNursingInformation({
          ElderlyCares:this.ElderlyCares,
          Items,
          NurseSignatureViews:this.NurseSignatureViews
        })
      }else{
        let editArr=this.implementHistory.filter(item=>item.IsEdit==1)
        this.$message({
          message: editArr.length?'不允许保存未来时间点的项目！':'请先选择项目!',
          type: 'warning',
          customClass:"custom-message"
        });
      }
    }
  },
  // 组件方法
  methods: {
    
    ...mapActions(['updateNursingInformation']),
    cloneDeep(val){
        return cloneDeep(val)
    },
    changeSize(size){
      this.size=size
    },
    changePage(page){
      this.page=page
    },
    //关闭执行弹框
    closeRemark(data){
        this.implementVisible=false
        this.activeObj={}
    },
    //取消缓存执行
    closeStatus(id){
        this.implementList.map(item=>{
            if(item.Id==id){
                this.reduction(item)
            }
        })
    },
    //取消执行还原对象
    reduction(item){
        let arr=[]
        item.IsEdit=0
        //还原完成执行缓存的对象
        arr=['oldStatus','oldValue','oldRemark','oldModels']
        arr.map((str)=>{
            if(item.hasOwnProperty(str)){
                //Models和oldModels不相等，重新赋值触发activeObj的更新从而触发:initModels="cloneDeep(activeObj.Models)"的更新
                item[str.substring(3)]=(str=='oldModels'?cloneDeep(item[str]):item[str])
            }
        })
    },
    //确认执行操作
    execution(data){
        this.implementList.map(item=>{
            if(item.Id==data.id){
                item.Status=data.status
                item.Remark=data.remark
                item.IsEdit=1
                //如果是确认执行，则对更新值和Models模型
                if(this.remakeType==1){
                    item.Value=data.input
                    item.Models=cloneDeep(data.models)
                    // item.Models=data.models
                //如果是确认未完成和备注，则要还原之前可能输入过的其他值
                }else if(this.remakeType==2){
                    item.Value=item.oldValue
                    item.Models=cloneDeep(item.oldRemark)  
                    // item.Models=item.oldModels
                }

            }
        })
    },
    //打开执行弹框
    check(data){
        // if (data.VitalId ||  data.InputType === 0 || data.InputType == 1 || data.InputType == 2) {
        if (data.VitalId ||  data.InputType == 1 || data.InputType == 2) {
            this.remakeType=1
            this.implementVisible=true
            this.activeObj= data
        }else{
          if(data.Status==0){
            data.Status=null
            data.IsEdit=0
          }else{
            data.Status=0
            data.IsEdit=1
          }
          this.activeObj= data
        }
    },
    //打开拒绝弹框
    close(data){
        this.remakeType=2
        this.implementVisible=true
        this.activeObj= data
    },
    //打开备注弹框
    setRemark(data){
        this.remakeType=3
        this.implementVisible=true
        this.activeObj= data
    },

    getHistory(obj){
        this.$router.push({
          name:'implementHistory' ,
          query: { Id:this.$route.query.Id ,itemId:obj.Id,message:obj.Message}
        })
    },
    allSetUp(val){
      this.dialogVisible=true
      this.isAll=val
      val?this.question='是否确认所有记录(不包含需要输入相关数值的记录)？':this.question='是否确认全部取消？'
    },
    allClose(){
      this.dialogVisible=false
    },
    //全部执行或取消
    allSetup(){
        // this.implementList.map(item=>{
        this.implementHistory.map((item,index)=>{
            //从未被执行过且是输入不需要输入特定值的 IsEdit接口返回的一直null，不能用来判断
            // if (item.oldStatus===null&&(item.InputType == 0||item.InputType == 3)) {
            if (item.oldStatus===null&&(!item.VitalId)) {
                if(this.isAll){
                    item.IsEdit=1
                    item.Status=0
                }else{
                    if(item.Status==0){
                        item.IsEdit=0
                        item.Status=item.oldStatus
                        item.Remark=item.oldRemark
                        item.Value=item.oldValue
                    }
                }
            }
        })
    },
    selectImplement(implementType){
      this.implementType=implementType
    }
    
  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
  * 在实例初始化之后，组件属性计算之前，如data属性等
  */
  beforeCreate () {
  },
  /**
  * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
  */
  created () {

  },
  /**
  * 在挂载开始之前被调用：相关的 render 函数首次被调用。
  */
  beforeMount () {
  },
  /**
  * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
  * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
  */
  mounted () {

  },
  /**
  * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
  * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  */
  beforeUpdate () {
  },
  /**
  * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
  * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
  */
  updated () {
  },
  /**
  * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
  */
  activated () {
  },
  /**
  * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
  */
  deactivated () {
  },
  /**
  * 实例销毁之前调用。在这一步，实例仍然完全可用。
  */
  beforeDestroy () {
      if(this.isAll){
        this.isAll=false
        this.allSetup()
      }
  },
  /**
  * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
  * 所有的事件监听器会被移除，所有的子实例也会被销毁。
  */
  destroyed () {
  }
}
</script> 

<style scoped>
.one-implement{
   padding: 0px 0px 60px 0px;
}
.one-implement-head{
    position: fixed;
    top: 89px;
    left: 0px;
    width: 100%;
    box-sizing: border-box;
    z-index: 1;
    padding: 15px;
    background: #fff;
}
.implement-image{
    width: 42px;
    height: 42px;
    border-radius: 21px;
    margin-right: 7px;
    border: 1px solid #029FD1;
    /* box-shadow: 0px 0px 10px 0px #888888; */
}
.one-implement-top{
    display: flex;
}
.implement-row{
    display: flex;
    justify-content: space-between;
}
.implement-list{
    margin: 208px 15px 0px 15px;
}
.name{
    font-size: 16px;
    font-weight: 500;
    color: #0A0E10;
    margin-right: 5px;
    font-family: 'PingFang SC Medium';
}
.level{
    font-size: 12px;
    font-weight: 400;
    color: #7C7E80;
    margin-right: 25px;
}
.room{
    font-size: 12px;
    font-weight: 400;
    color: #029FD1 !important;
}
.implement-message{
    display: flex;
    align-items: center;
}
.implement-num{
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #F32E2F;
}
.implement-all-check{
    margin-right: 4px;
}
.implement-filter{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 15px;
}
.implement-item{
    margin: 12px 0px;
    padding: 12px;
    background: #fff;
    border-radius: 8px;
}
.line{
    width: 100%;
    height: 1px;
    background: #EBEBEB;
}
.time{
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 20px;
    color: #434649;
}
.btn-list{
    display: flex;
    align-content: center;
}
.all-btn{
    font-size: 12px;
    width:67px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    border-radius: 2px;
    box-sizing: border-box;
}
.all-cancel{
    background: #DCF7FF;
    color: #029FD1;
    border: 1px solid #029FD1;
}
.all-sure{
    background: #029FD1;
    color: #FFFFFF;
    margin-left: 15px;
}
.implement-row{
  position: fixed;
  top: 200px;
  left: 0px;
  font-size: 16px;
  width: 100%;
  padding: 16px 15px;
  display: flex;
  justify-content: space-between;
  background: #F7F8FA;
  box-sizing: border-box;
  z-index: 1;
}
.already-implement,.not-implement{
  position: relative;
  width: 168px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  background-color: #DCF7FF;
  color: #029FD1;
}
.already-implement::after{
  position: absolute;
  right: -12px;
  top: 0;
  width: 0;
  height: 0;
  border-top: 36px solid #DCF7FF;
  border-right: 12px solid transparent;
  content: "";
}
.not-implement::after{
  position: absolute;
  left: -12px;
  top: 0;
  width: 0;
  height: 0;
  border-bottom: 36px solid #DCF7FF;
  border-left: 12px solid transparent;
  content: "";
}
.active-implement{
  background-color: #029FD1;
  color: #fff;
}
.active-implement::after{
  border-top-color: #029FD1;
  border-bottom-color: #029FD1;
}
</style>



// WEBPACK FOOTER //
// src/components/nursing/nursing-one-implement.vue